import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import AdmSignIn from '../pages/AdmSignIn';
import AutoLogin from '../pages/AutoLogin';
import ForgotPassword from '../pages/ForgotPassword';
import ResetPassword from '../pages/ResetPassword';
import SignIn from '../pages/SignIn';
import Application from '../pages/application';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/autologin" exact component={AutoLogin} />
      <Route path="/admsignin" exact component={AdmSignIn} />
      <Route path="/forgot-password" exact component={ForgotPassword} />
      <Route path="/reset-password" exact component={ResetPassword} />
      <Route path="/app*" exact component={Application} isPrivate />
    </Switch>
  );
};

export default Routes;
